export const COOKIE_CONSENT_KEY = 'goodvale_cookie_consent';
export const UMAMI_DISABLED_KEY = 'umami.disabled';
export const DIAGNOSTICS_CONSENT_KEY = 'goodvale_diagnostics_consent';

export function isDiagnosticsEnabled() {
  return typeof localStorage !== 'undefined' && localStorage.getItem(DIAGNOSTICS_CONSENT_KEY) === 'granted';
}

export function openCookieBanner() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('open-cookie-banner'));
  }
}

export function isTrackingEnabled() {
  if (typeof localStorage === 'undefined') return false;
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  const umamiDisabled = localStorage.getItem(UMAMI_DISABLED_KEY);
  return consent === 'granted' && umamiDisabled !== '1';
}

export function setTrackingConsent(granted, diagnostics = false) {
  if (typeof localStorage === 'undefined') return;
  if (granted) {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'granted');
    localStorage.removeItem(UMAMI_DISABLED_KEY);
  } else {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    localStorage.setItem(UMAMI_DISABLED_KEY, '1');
  }
  localStorage.setItem(DIAGNOSTICS_CONSENT_KEY, diagnostics ? 'granted' : 'declined');
  window.dispatchEvent(new Event("tracking-consent-changed"));
}
